var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { PDFPrinter } from '../helpers/PDFPrinter';
export class PDFPrinterComponent extends Component {
    constructor() {
        super('PDFPrinterComponent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            yield Promise.all(['Pangram'].map((fontName) => __awaiter(this, void 0, void 0, function* () {
                var font = yield $.httpRequest({
                    url: '/wp-content/themes/hanako-wp/pdf-fonts/' + fontName + '.b64',
                    dataType: 'text'
                });
                PDFPrinterComponent.fonts[fontName] = font;
            })));
            $('.btn-download-pdf').on('click', (event) => {
                event.preventDefault();
                $('#diagram, #recommendations').addClass('show');
                PDFPrinter.print($('#synthesis'), $('#document-title').text());
            });
            this.success();
        });
    }
}
PDFPrinterComponent.fonts = {};
